import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import { CircularProgress, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { Buffer } from "buffer";
import { memo } from "react";
import { useEffect } from "react";
import {
  PartiesFields,
  creditNote,
  debitNote,
  journalEntry,
  partiesDeliveryFields,
  paymentField,
  purchaseFields,
  receiptEntry,
  salesFields,
} from "../../utils/module_fields_data";
import { useSelector } from "react-redux";
import API_ENDPOINTS from "../../apiEndpoints";

const options = ["XLSX", "CSV"];

function ExportData({ setOpen, open, item }) {
  const items = [
    { label: "Goods", value: "GOODS" },
    { label: "Customers", value: "CUSTOMER" },
    { label: "Services", value: "SERVICE" },
    { label: "Suppliers", value: "SUPPLIER" },
    { label: "PURCHASE", value: "PURCHASE" },
    { label: "INVOICE", value: "INVOICE" },
    { label: "PAYMENT", value: "PAYMENT" },
    { label: "Receipt", value: "Receipt" },
    { label: "Journal Entries", value: "JOURNAL" },
    { label: "Debit Note", value: "DEBITNOTE" },
    { label: "Credit Note", value: "CREDITNOTE" },
  ];
  const module = items.find((module) => module.label === item);

  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [exporting, setExporting] = useState(false);
  const [formatError, setFormatError] = useState("");
  const [fieldsError, setfieldsError] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [companyDetails, setComapanyDetails] = useState();
  const [GSFields, setGSFields] = useState([]);
  const [CSFields, setCSFields] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);

  useEffect(() => {
    if (companyDetails) filterFields();
  }, [companyDetails, item]);

  useEffect(() => {
    if (selectedFormat && selectedFields.length > 0) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [selectedFields, selectedFormat]);

  async function filterFields() {
    if (companyDetails?.relatedcompanydetailsnew[0]?.registrationtype === 1) {
      const newArray = fields1.filter((obj) => obj.required !== 2);
      newArray.push({ label: "Amount", value: "Amount(Inc.GST)", required: 1 });
      // setGSFields(newArray);
      const csNewArray = fields2.filter((obj) => obj.required !== 2);
      if (item === "Customers") {
        const csNewArray2 = field3.filter((obj) => obj.required !== 2);
        setCSFields([...csNewArray, csNewArray2]);
      } else {
        setCSFields(csNewArray);
      }
    } else {
      if (item === "Customers")
        setCSFields([...PartiesFields, ...partiesDeliveryFields]);
      else if (item === "Suppliers") setCSFields(PartiesFields);
      else if (item === "Goods" || item === "Services") setGSFields(fields1);
    }
  }
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  async function getCompanyDetails() {
    try {
      setBackdropOpen(true);
      const data = getCompany;
      console.log(data);
      setComapanyDetails(data);
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      alert("fetching issue");
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, [getCompany]);
  const handleClose = () => {
    setOpen(false);
    setSelectedFields([]);
    setSelectedFormat(null);
    setFormatError("");
    setfieldsError("");
  };

  const handleFormatChange = (event) => {
    setSelectedFormat(event.target.value);
    setFormatError("");
  };

  const validateformat = (value) => {
    return !value ? "This field is required*" : "";
  };
  const validateField = (value) => {
    return value.length > 0 ? "" : "Please select at least one option*";
  };

  const fields1 = [
    { label: "Category", value: "Category", required: 1 },
    { label: "Unit of Measurement", value: "Unit of Measurement", required: 1 },
    { label: "Sales Account", value: "Sales Account", required: 1 },
    { label: "Purchase Account", value: "Purchase Account", required: 1 },
    { label: "Taxability", value: "Taxability", required: 2 },
    { label: "Reverse Charge", value: "Reverse Charge", required: 2 },
    {
      label: "Current Selling Price(Per Unit Exc.GST)",
      value: "Current Selling Price(Per Unit Exc.GST)",
      required: 1,
    },
    { label: "GST Rate(%)", value: "GST Rate(%)", required: 2 },
    { label: "Cess Type", value: "Cess Type", required: 2 },
    { label: "Cess", value: "Cess", required: 2 },
    {
      label: "Selling Price Effective From",
      value: "Selling Price Effective From",
      required: 1,
    },
    {
      label: "Selling Price Effective To",
      value: "Selling Price Effective To",
      required: 1,
    },
    { label: "Amount(Inc.GST)", value: "Amount(Inc.GST)", required: 2 },
  ];

  const fields2 = [
    { label: "Email", value: "Email", required: 1 },
    { label: "Contact Number", value: "Contact Number", required: 1 },
    { label: "WhatsApp Number", value: "WhatsApp Number", required: 1 },
    { label: "Party Group", value: "Party Group", required: 1 },
    { label: "GST Category", value: "GST Category", required: 2 },
    { label: "GSTIN", value: "GSTIN", required: 2 },
    {
      label: "Permanent Account Number",
      value: "Permanent Account Number",
      required: 1,
    },
    { label: "Place of Supply", value: "Place of Supply", required: 1 },
    { label: "Entity", value: "Entity", required: 1, required: 1 },
    {
      label: "State/Province",
      value: "State/Province",
      required: 1,
      required: 1,
    },
    { label: "Country", value: "Country", required: 1 },
    { label: "Billing Address", value: "Billing Address", required: 1 },
    {
      label: "Billing Address District",
      value: "Billing Address District",
      required: 1,
    },
    {
      label: "Billing Address State",
      value: "Billing Address State",
      required: 1,
    },
    {
      label: "Billing Address Country",
      value: "Billing Address Country",
      required: 1,
    },
    {
      label: "Billing Address PIN Code",
      value: "Billing Address PIN Code",
      required: 1,
    },
  ];

  const field3 = [
    { label: "Consignee Name", value: "Consignee Name", required: 2 },
    { label: "Consignee GSTIN", value: "Consignee GSTIN", required: 2 },
    { label: "Delivery Address", value: "Delivery Address", required: 1 },
    {
      label: "Delivery Address District",
      value: "Delivery Address District",
      required: 1,
    },
    {
      label: "Delivery Address State",
      value: "Delivery Address State",
      required: 1,
    },
    {
      label: "Delivery Address Country",
      value: "Delivery Address Country",
      required: 1,
    },
    {
      label: "Delivery Address PIN Code",
      value: "Delivery Address PIN Code",
      required: 1,
    },
    {
      label: "Primary Contact Name",
      value: "Primary Contact Name",
      required: 1,
    },
  ];

  const handleFieldChange = (value) => {
    setfieldsError("");
    setSelectedFields((prevSelectedFields) => {
      if (prevSelectedFields.includes(value)) {
        return prevSelectedFields.filter((field) => field !== value);
      } else {
        return [...prevSelectedFields, value];
      }
    });
  };

  const handleSelectAll = (event) => {
    setfieldsError("");
    const selectAll = event.target.checked;
    if (selectAll) {
      setSelectedFields(
        item === "Goods" || item === "Services"
          ? GSFields
          : item === "Customers"
          ? CSFields
          : item === "Suppliers"
          ? CSFields
          : item === "PURCHASE"
          ? purchaseFields
          : item === "INVOICE"
          ? salesFields
          : item === "PAYMENT"
          ? paymentField
          : item === "Receipt"
          ? receiptEntry
          : item === "Journal Entries"
          ? journalEntry
          : item === "Debit Note"
          ? debitNote
          : item === "Credit Note"
          ? creditNote
          : []
      );
    } else {
      setSelectedFields([]);
    }
  };

  const handleExport = async () => {
    const formatValidationResult = validateformat(selectedFormat);
    const selectfieldsValidationResult = validateField(selectedFields);
    setFormatError(formatValidationResult);
    setfieldsError(selectfieldsValidationResult);
    console.log(formatValidationResult, selectfieldsValidationResult);
    if (formatValidationResult === "" && selectfieldsValidationResult === "") {
      setExporting(true);
      let fields = [...selectedFields];
      try {
        let accessToken;

        // Iterate through localStorage keys
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (
            key.startsWith("CognitoIdentityServiceProvider") &&
            key.endsWith(".accessToken")
          ) {
            accessToken = localStorage.getItem(key);
            break;
          }
        }
        console.log(module);
        const requestData = {
          format: selectedFormat,
          module: module.value,
          fields: fields,
          authorization: accessToken,
        };

        const option = {
          method: "POST",
          url: API_ENDPOINTS.REACT_APP_EXPORT_DATA_URL,
          data: requestData,
        };

        const response = await axios(option);

        if (response.status === 200) {
          const contentType = response.headers["content-type"];
          const format =
            contentType === "text/csv"
              ? "csv"
              : contentType ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ? "xlsx"
              : "";
          const buffer = Buffer.from(response.data.data);
          const blob = new Blob([buffer]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          const currentDate = new Date();
          const formattedDate = currentDate.toISOString().slice(0, 10);
          a.download = `ledgerX_Export_${item}_${formattedDate}.${format}`;
          document.body.appendChild(a);
          a.click();
          setExporting(false);
          setOpen(false);
          setSelectedFields([]);
          setSelectedFormat(null);
          setFormatError("");
          setfieldsError("");
        } else {
          setExporting(false);
          console.log("Error");
        }
      } catch (error) {
        setExporting(false);
        console.log(error.message);
      }
    }
  };

  const disableField1 = ["Item Code", "Item Name"];

  const renderFields = (fields) => (
    <>
      {item === "Goods" || item === "Services"
        ? disableField1.map((field, index) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={4}
              key={index}
              sx={{ maxHeight: { xs: "30px", lg: "45px" } }}
            >
              <FormControlLabel
                control={<Checkbox checked="true" disabled />}
                label={
                  <Typography variant="body2" sx={{ fontSize: "12px" }}>
                    {field}
                  </Typography>
                }
              />
            </Grid>
          ))
        : null}

      {fields.map((field, index) => (
        <Grid
          item
          xs={6}
          sm={4}
          md={4}
          key={index}
          sx={{ maxHeight: { xs: "30px", lg: "45px" } }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.some(
                  (item) => item.value === field.value
                )}
                onChange={() => handleFieldChange(field)}
                value={field}
              />
            }
            label={
              <Typography variant="body2" sx={{ fontSize: "12px" }}>
                {field.label}
              </Typography>
            }
          />
        </Grid>
      ))}
    </>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="export-data-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0, // Align modal to the bottom
          minHeight: "90%",
          width: "90%",
          maxWidth: "500px",
          backgroundColor: "#fff",
          boxShadow: 24,
          p: 3,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" id="export-data-modal-title" gutterBottom>
          Export Data : Items - {item}
        </Typography>
        <Box>
          <FormControl
            variant="outlined"
            sx={{ width: "100%", marginTop: 2, marginBottom: 3 }}
          >
            <InputLabel required>Select Format</InputLabel>
            <Select
              value={selectedFormat}
              onChange={handleFormatChange}
              label="Select Format"
              sx={{
                ".MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            >
              {options.map((option, idx) => (
                <MenuItem key={idx} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {formatError && (
              <div style={{ color: "red", marginTop: "4px", fontSize: "13px" }}>
                {formatError}
              </div>
            )}
          </FormControl>
        </Box>

        <Typography variant="subtitle1">Select Fields to Export</Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                selectedFields.length ===
                (item === "Goods" || item === "Services"
                  ? GSFields.length
                  : item === "Customers"
                  ? CSFields.length
                  : item === "Suppliers"
                  ? CSFields.length
                  : item === "PURCHASE"
                  ? purchaseFields.length
                  : item === "INVOICE"
                  ? salesFields.length
                  : item === "PAYMENT"
                  ? paymentField.length
                  : item === "Receipt"
                  ? receiptEntry.length
                  : item === "Journal Entries"
                  ? journalEntry.length
                  : item === "Debit Note"
                  ? debitNote.length
                  : item === "Credit Note"
                  ? creditNote.length
                  : null)
              }
              onChange={handleSelectAll}
            />
          }
          label="Select All"
        />
        <Grid container spacing={1} sx={{ overflowY: { lg: "auto" } }}>
          {item === "Goods" || item === "Services"
            ? renderFields(GSFields)
            : item === "Customers"
            ? renderFields(CSFields)
            : item === "Suppliers"
            ? renderFields(CSFields)
            : item === "PURCHASE"
            ? renderFields(purchaseFields)
            : item === "INVOICE"
            ? renderFields(salesFields)
            : item === "PAYMENT"
            ? renderFields(paymentField)
            : item === "Receipt"
            ? renderFields(receiptEntry)
            : item === "Journal Entries"
            ? renderFields(journalEntry)
            : item === "Debit Note"
            ? renderFields(debitNote)
            : item === "Credit Note"
            ? renderFields(creditNote)
            : null}
        </Grid>
        {fieldsError && (
          <div style={{ color: "red", marginTop: 2, fontSize: "13px" }}>
            {fieldsError}
          </div>
        )}

        <Box sx={{ position: "absolute", bottom: "16px", right: "16px" }}>
          <Button
            disabled={disableButton}
            variant="outlined"
            onClick={handleClose}
            sx={{ marginRight: "8px" }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleExport}
            variant="contained"
            color="primary"
            startIcon={
              exporting ? (
                <CircularProgress disableShrink size={24} color="inherit" />
              ) : (
                <CloudDownloadIcon />
              )
            }
            disabled={exporting || disableButton}
          >
            {exporting ? "Exporting..." : "Export"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default memo(ExportData);
